import { useTranslation } from "react-i18next";
import LoaderDialog from "../LoaderDialog";

type Props = {
	visible: boolean;
	completed: number | null;
	total: number;
};

const FinalizingResultsLoader = ({ visible, completed, total }: Props) => {
	const { t } = useTranslation();

	const messages = [
		{
			icon: "progress-check" as const,
			text:
				completed != null && total > 0
					? t("session.finalizing.gradingProgress")
					: t("session.finalizing.title"),
		},
	];

	return <LoaderDialog visible={visible} messages={messages} />;
};

export default FinalizingResultsLoader;
